function Loading({ isLoading }) {
  return (
    <div className="loading-screen" aria-busy={isLoading} aria-live="polite">
      <div className="loading-inner">
        <p className="loading-brand">Julien Jacobs</p>
        <p className="loading-sub">Portfolio</p>
        <div className="loading-bar" aria-hidden="true">
          <span />
        </div>
      </div>
    </div>
  );
}

export default Loading;
